/**
 * @module
 * @name Empty
 * @description Functional component to use as empty content.
 */
export default {
  name: 'Empty',
  /**
   * @property {String} icon VueSVGIcon name.
   * @property {String} title Title.
   * @property {String} descr Description.
   */
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    descr: {
      type: String,
      required: true
    }
  }
}
